<template>
  <div class="container_top">
    <div class="filter_back" @click="$router.go(-1)"></div>
    <div class="back_text">OTA详情</div>
  </div>
  <div class="white_bg">
    <NodeName node_name="OTA升级详情" />
    <div class="ota_options">
      <div class="ota_options_left">
        <div class="ota_option">
          <div class="ota_attr">推送版本：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && (detailData.version_info.system + ' ' +
            detailData.version_info.version) }}</div>
        </div>
        <div class="ota_option">
          <div class="ota_attr">推送时间：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && detailData.version_info.upgrade_date }}</div>
        </div>
        <div class="ota_option">
          <div class="ota_attr">推送类型：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && (detailData.version_info.type ==
            1 ? '免费' : detailData.version_info.type == 2 ? '收费' : '') }}</div>
        </div>
        <div class="ota_option">
          <div class="ota_attr">用户关注度：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && detailData.version_info.popular }}</div>
        </div>

        <div class="comment-item">
          <div class="comment-title">用户评价</div>
          <div class="comment-line">
            <div class="comment-line-left"></div>
            <div class="comment-line-right"></div>
          </div>
          <div class="comment-content">
            {{ detailData && detailData.version_info && detailData.version_info.user_comment }}
          </div>
        </div>

        <div>
          <div class="comment-title">专家评价</div>
          <div class="comment-line">
            <div class="comment-line-left"></div>
            <div class="comment-line-right"></div>
          </div>
          <div class="comment-content">
            {{ detailData && detailData.version_info && detailData.version_info.expert_comment }}
          </div>
        </div>

      </div>
      <div class="ota_options_right">
        <div class="ota_option">
          <div class="ota_attr">更新级别：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && (detailData.version_info.level ==
            1 ? '重要' : detailData.version_info.level ==
              2 ? '中等' : detailData.version_info.level == 3 ? '紧急' : detailData.version_info.level == 4 ? '低' : '') }}
          </div>
        </div>
        <div class="ota_option">
          <div class="ota_attr">更新内容：</div>
          <div class="ota_val">{{}}</div>
        </div>
        <div class="ota_option">
          <div class="ota_attr">车型范围：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && detailData.version_info.serie.join(',') }}
          </div>
        </div>
        <div class="ota_option">
          <div class="ota_attr">用户反馈：</div>
          <div class="ota_val">{{ detailData && detailData.version_info && detailData.version_info.feedback_type }}</div>
        </div>
      </div>
    </div>

    <div class="ota_details" v-if="detailData && detailData.ota_list && detailData.ota_list.length">
      <div class="ota_detail_item" v-for="(item, ind) in detailData.ota_list" :key="ind">
        <div class="ota_item_tit">
          {{ ind + 1 }}. {{ item.title }}
        </div>
        <div class="ota_item_content" v-if="item.content_list[0] && item.content_list[0]['content'] != '' && (item.content_list.length || item.media_list.length)">
          <div class="ota_item_texts" v-if="item.content_list.length">
            <div class="ota_item_text" v-for="(ct_item, ct_ind) in item.content_list" :key="ct_ind">
              <span class="dian">●</span> {{ ct_item.content }}
            </div>
          </div>
          <div class="ota_item_medias" v-if="item.media_list.length">
            <div class="ota_item_media" v-for="(media_item, media_ind) in item.media_list" :key="media_ind">
              <template v-if="media_item.type == 1">
                <el-image style="width: 100%; height: 100%" :src="media_item.url" :preview-src-list="[media_item.url]"
                  fit="cover" />
              </template>
              <template v-else-if="media_item.type == 2">
                <video :src="media_item.url" :poster="(media_item.url) +
                  '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
                  " preload="none" @click="playVideo(media_item)"></video>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="video_pop" v-show="video_show">
      <div class="video_content">
        <video controlsList="nodownload" :src="video_src" autoplay controls :poster="video_src +
          '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
          " preload="metadata"></video>
        <div class="video_close" @click="stopVideo"></div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  ref
} from "vue";
import {
  useRoute
} from "vue-router";
import {
  getOtaDetail
} from "@/api";
import {
  ElImage
} from "element-plus"
import NodeName from "@/components/common/views/NodeName.vue";
export default {
  components: {
    NodeName,
    ElImage
  },
  setup() {
    const route = useRoute();
    const detailData = ref(null);
    const getDetailFn = () => {
      getOtaDetail({
        version_id: route.query.id
      }).then(res => {
        console.log(res);
        detailData.value = res.data
      })
    }
    getDetailFn();
    const video_src = ref("");
    const video_show = ref(false);
    const playVideo = (video_obj) => {
      video_src.value = video_obj.url;
      video_show.value = true;
    };
    const stopVideo = () => {
      video_src.value = "";
      video_show.value = false;
    };
    return {
      detailData,
      stopVideo,
      playVideo,
      video_src,
      video_show,
    }
  }
}
</script>

<style lang="less" scoped>
.container_top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .filter_back {
    width: 40px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/back_20230221.svg) no-repeat center center;
    background-size: 18px;
  }

  .back_text {
    color: #777c89;
    font-size: 14px;
  }
}

.white_bg {
  min-height: calc(100vh - 128px);
  padding: 30px 56px 48px 59px;
}

.ota_options {
  margin-top: 36px;
  width: 1109px;
  background: #F6F9FD;
  border-radius: 2px;
  display: flex;
  padding: 21px 40px;

  .ota_option {
    display: flex;
    align-items: center;
    height: 41px;

    .ota_attr {
      font-size: 16px;
      font-weight: bold;
      color: #191919;
    }

    .ota_val {
      font-size: 16px;
      color: #191919;
    }
  }

  .ota_options_left {
    padding-right: 80px;
    min-width: 220px;
    max-width: 50%;
  }

  .ota_options_right {
    max-width: 50%;
  }
}

.ota_details {
  .ota_detail_item {
    margin-top: 20px;

    .ota_item_tit {
      font-size: 16px;
      font-weight: 500;
      color: #191919;
      line-height: 21px;
    }

    .ota_item_content {
      margin-top: 10px;
      padding: 17px 31px 0;
      background: #F9F9F9;
      border-radius: 2px;

      .ota_item_texts {
        padding-bottom: 20px;

        .ota_item_text {
          font-size: 14px;
          color: #2A2A2A;
          line-height: 26px;

          .dian {
            font-size: 12px;
          }
        }
      }

      .ota_item_medias {
        display: flex;
        flex-wrap: wrap;

        .ota_item_media {
          width: 316px;
          height: 202px;
          margin-right: 20px;
          margin-bottom: 20px;

          video,
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
}

.video_pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;

  .video_content {
    width: 100%;
    height: 100%;

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .video_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      right: 50px;
      top: 50px;
    }
  }
}

.comment-title {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}

.comment-line {
  display: flex;
  margin-top: 17px;
  margin-bottom: 13px;
}

.comment-line-left {
  width: 20px;
  height: 2px;
  background: #1FBCBF;
}

.comment-line-right {
  width: 76px;
  height: 2px;
  background: #DCDCDC;
}

.comment-content {
  font-size: 14px;
  color: #191919;
  width: 1050px;
  margin-bottom: 20px;
}

.comment-item {
  margin-top: 25px;
}
</style>